/* eslint-disable import/prefer-default-export */

import isEmptyUtil from '@utils/isEmpty';
import {
  bloodGroups,
  classes,
  candidateIdTypes,
  parentIdTypes
} from '../constants';

export const stepNumbers = {
  ONE: 1,
  TWO: 2
};

export const isRequired = (errorMessage) => (value) => {
  if (isEmptyUtil(value)) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};

export const isLengthMatchError = (errorMessage, length) => (value) => {
  if (value.toString().length !== length) {
    return {
      error: true,
      message: errorMessage
    };
  }
};

export const isNumericOnlyError = (errorMessage) => (value) => {
  if (/[^0-9a-zA-Z]/.test(value)) {
    return {
      error: true,
      message: errorMessage
    };
  }
};

export const isValidName = (errorMessage, length) => (value) => {
  if (value.toString().length > length) {
    return {
      error: true,
      message: errorMessage
    };
  }
};

export const modifyData = (formData) => {
  const bloodGroup = bloodGroups.find(
    (group) => group.value === formData?.bloodGroup
  );
  const candidateIdType = candidateIdTypes.find(
    (group) => group.value === formData?.candidateIdType
  );
  const learnerClass = classes.find(
    (classObj) => classObj.value === formData?.class
  );
  const ParentIdType = parentIdTypes.find(
    (group) => group.value === formData?.parentIdType
  );
  return {
    ...formData,
    bloodGroup,
    candidateIdType,
    ParentIdType,
    class: learnerClass
  };
};

export const isImageTypeValid = (errorMessage) => (value) => {
  if (value?.message === 'Not a valid image extension') {
    return {
      error: true,
      message: errorMessage
    };
  }
};

export const isImageSizeValid = (errorMessage) => (value) => {
  if (value?.size / 1000 > 10000) {
    return {
      error: true,
      message: errorMessage
    };
  }
};

export const checkAlphabetic = (onChange, data, isNameField = false) => {
  try {
    const char = data.nativeEvent?.data || data.nativeEvent?.target?.value;
    const isBackwardButtonPressed =
      data.nativeEvent.inputType === 'deleteContentBackward';
    const regex = isNameField
      ? /^[a-zA-Z0-9!@#$%^&*ëé)(+=._-]+$/g
      : /^[a-z]+$/i;
    const isWordPasted =
      data.nativeEvent.inputType === 'insertFromPaste' &&
      regex.test(data.target.value);

    const trimmedChar = char && regex.test(char.replaceAll(/\s/g, ''));

    if (
      trimmedChar ||
      isWordPasted ||
      isBackwardButtonPressed ||
      char === ' '
    ) {
      onChange(data.target.value);
      return true;
    }
  } catch (error) {
    return false;
  }
};

export const checkNumberic = (onChange, data) => {
  const char = data.nativeEvent.data;
  const isBackwardButtonPressed =
    data.nativeEvent.inputType === 'deleteContentBackward';
  const regex = /^[0-9]+$/;
  const isWordPasted =
    data.nativeEvent.inputType === 'insertFromPaste' &&
    regex.test(data.target.value);
  const isLengthMore = data?.target.value.length > 6;
  if (
    ((char && regex.test(char)) ||
      isWordPasted ||
      isBackwardButtonPressed ||
      char === ' ') &&
    !isLengthMore
  ) {
    onChange(data.target.value);
    return true;
  }
};

export const isIdLengthValidError = (errorMessage, idType) => (value) => {
  let minLength = 0;
  let maxLength = 0;
  switch (idType) {
    case 'AADHAR card':
      minLength = 12;
      maxLength = 12;
      break;
    case 'Passport':
      minLength = 9;
      maxLength = 9;
      break;
    case 'School ID':
      minLength = 3;
      maxLength = 15;
      break;
    case 'Voter ID':
      minLength = 10;
      maxLength = 10;
      break;
    case 'Driving license':
      minLength = 15;
      maxLength = 15;
      break;
    case 'PAN card':
      minLength = 10;
      maxLength = 10;
      break;
    default:
      minLength = 0;
      maxLength = 20;
      break;
  }

  if (value.length < minLength || value.length > maxLength) {
    return {
      error: true,
      message: errorMessage
    };
  }

  return {};
};
